import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import { Invoice } from 'api/billing/types'
import { getInvoices } from 'api/billing'


type UseGetInvoicesConfig = (
  partnerIds: (string | number)[] | null | undefined
) => [
  {
    isLoading: boolean
    isError: boolean
    invoices?: Invoice[]
  },
]

const useGetInvoices: UseGetInvoicesConfig = (partnerIds) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [invoices, setInvoices] = useState<Invoice[] | undefined>(undefined)

  useEffect(() => {
    const fetchInvoices = async () => {
      if (!partnerIds || isEmpty(partnerIds)) {
        setInvoices([])
        return
      }

      setIsLoading(true)
      setIsError(false)

      try {
        const invoicePromises: Promise<Invoice[]>[] = partnerIds.map((id) =>
          getInvoices({ partnerId: id })
        )
  
        const results: PromiseSettledResult<Invoice[]>[] = await Promise.allSettled(invoicePromises)
  
        const successfulResults = results.filter(
          (res): res is PromiseFulfilledResult<Invoice[]> =>
            res.status === 'fulfilled'
        )
  
        const allInvoices = successfulResults.flatMap((res) => res.value)
        setInvoices(allInvoices)
      } catch (err) {
        console.error(err)
        setInvoices([])
        setIsError(true)
      } finally {
        setIsLoading(false)
      }
    }

    fetchInvoices()
  }, [partnerIds])

  return [
    {
      isLoading,
      isError,
      invoices,
    },
  ]
}

export default useGetInvoices